import React from "react";

export default function InfoCard({ icon: Icon, title, desc }) {
  const renderDesc = () => {
    if (Array.isArray(desc)) {
      return (
        <ul
          className={`flex justify-center items-center font-bold ${
            desc.length > 4
              ? "grid grid-cols-3 md:grid-cols-4 gap-0.5"
              : "gap-2"
          }`}
        >
          {desc.map((item, index) => (
            <li key={index} className="">
              {item}
            </li>
          ))}
        </ul>
      );
    }
    return <p className="font-bold">{desc}</p>;
  };

  return (
    <div className="flex flex-col justify-center items-center shadow-gray-500 shadow w-[156px] h-[156px] md:h-[166px] md:w-[166px] rounded">
      <Icon className="w-12 h-12 text-amber-400 stroke-1" />
      <div className="text-sm">{title}</div>
      {renderDesc()}
    </div>
  );
}
